<div nxLayout="grid maxwidth" *ngIf="activePolicies">
  <div nxRow>
    <div nxCol="12" class="docs-grid-colored-col policies">
      <div class="my-policies">

        <div class="heading">
          <div class="heading-content">
            <h3 nxHeadline="subsection-medium" translate class="title">policy.my-policies</h3>
          </div>
          <div class="heading-tabs">
            <cpc-tab-selector-group>
              <cpc-tab-selector *ngFor="let content of ['active', 'past']; let i = index"
                [selected]="selectedIndex === i" (click)="tabChanged(i)">
                {{ 'product-state.'+content | translate }}
              </cpc-tab-selector>
            </cpc-tab-selector-group>
          </div>
        </div>

        <div *ngIf="selectedIndex==0">
          <div nxRow class="tab-content">
            <ng-template ngFor let-policy="$implicit" [ngForOf]="activePolicies">
              <div nxCol="12, 12, 12, 12, 6" class="policy-column">
                <app-policy-individual-card [policy]="policy" [state]="policyStates.active"></app-policy-individual-card>
              </div>
            </ng-template>
            <div nxCol="12, 12, 12, 12, 6" class="policy-column" *ngIf="activePolicies.length === 1">
              <nx-card class="special-offer">
                <h3 nxHeadline="subsection-small" translate>policy.special-offer.title</h3>
                <p translate>policy.special-offer.description</p>
                <div [innerHTML]="'policy.special-offer.list' | translate"></div>
                <button nxButton="primary small" type="button"
                  (click)="openLink(specialOffer.learnMoreUrl)">{{'policy.special-offer.see-offer' |
                  translate}}</button>
                <cpc-illustration name="manHoldingBox" width="220px">
                </cpc-illustration>
              </nx-card>
            </div>
          </div>
        </div>
        <div *ngIf="selectedIndex==1">
          <div nxRow class="tab-content">
            <ng-template ngFor let-policy="$implicit" [ngForOf]="inactivePolicies">
              <div nxCol="12, 12, 12, 12, 6" class="policy-column">
                <app-policy-individual-card [policy]="policy" [state]="policyStates.past"></app-policy-individual-card>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-help page="my-policy"></app-help>
